import { render, staticRenderFns } from "./TabDetails.vue?vue&type=template&id=58d97c0b&scoped=true&"
import script from "./TabDetails.vue?vue&type=script&lang=coffee&"
export * from "./TabDetails.vue?vue&type=script&lang=coffee&"
import style0 from "./TabDetails.vue?vue&type=style&index=0&id=58d97c0b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d97c0b",
  null
  
)

export default component.exports